import { useLayoutEffect, useRef, useState } from 'react';

export default function useContainerSize<T extends HTMLElement>() {
  const ref = useRef<T>(null);
  const [size, setSize] = useState({ width: 0, height: 0 });

  useLayoutEffect(() => {
    const element = ref.current;
    if (!element) return undefined;
    const { width, height } = element.getBoundingClientRect();
    setSize({ width, height });

    const observer = new ResizeObserver((entries) => {
      if (!entries.length) return;
      const { width: observedWidth, height: observedHeight } = entries[0].contentRect;
      setSize({ width: observedWidth, height: observedHeight });
    });
    observer.observe(element);
    return () => observer.disconnect();
  }, []);

  return [ref, size] as const;
}
